import React from 'react';
import ReactDOM from 'react-dom';
import MenuProducts from './menu-products';

const { Order } = Mobi2Go;
const element = document.querySelector('[data-view="menu-products"]');

Order.onMenuReady(() =>
    ReactDOM.render(<MenuProducts root={element} />, element)
);
